<template>
  <div style="width: 100%;">
    <v-select
        :value="processImport"
        background-color="white"
        color="backgrey"
        :items="processesImportNames"
        :placeholder="placeholderInput"
        outlined
        dense
        @change="onChangeInput"
        hide-selected
        hide-details
    >
      <template slot="item" slot-scope="data">
        <span class="titleslight--text " v-if="!Boolean(data.item.length)">Deseleccionar</span>
        <span v-else-if="processImport  !== data.item" class="third--text fs-1_3 ">{{ data.item }}</span>
      </template>
      <template slot="selection" slot-scope="data">
        <span class="titleslight--text " v-if="!Boolean(data.item.length)">{{ placeholderInput }}</span>
        <span class="third--text">{{ data.item }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    processesImportNames: {
      type: Array,
      default: () => ([])
    },
    processImport: {
      type: String,
      default: ""
    },
    placeholderInput: {
      type: String,
      default: ""
    },
    onChangeInput: {
      type: Function,
      default: ()=>{}
    }
  }
}
</script>

<style scoped>

</style>
